import { PermissaoEnum } from "core/resources/enums/permissao";

export enum TabsMenuOptionsRoutes {
  Dados = "dados",
  UsuariosLegais = "usuarios_legais",
  Unidades = "unidades",
  CentrosDeCusto = "centros_de_custo",
  ContaBancarias = "contas_bancarias",
  MetodosCobranca = "metodos-cobranca",
  PlanoDeContas = "plano_de_contas",
  GruposDeDesconto = "grupos-de-desconto",
  Parametrizacoes = "parametrizacoes-de-cobranca",
  InstrucaoBoleto = "instrucao-boleto",
  Feriados = "feriados",
  WhiteLabel = "whitelabel",
}

export const TabMenuOptions: {
  label: string;
  route: TabsMenuOptionsRoutes;
  permissions: string[];
}[] = [
  {
    label: "Dados Cadastrais",
    route: TabsMenuOptionsRoutes.Dados,
    permissions: [],
  },
  // {
  //   label: "Unidades",
  //   route: TabsMenuOptionsRoutes.Unidades,
  //   permissions: [],
  // },
  {
    label: "Responsáveis Legais",
    route: TabsMenuOptionsRoutes.UsuariosLegais,
    permissions: [],
  },
  {
    label: "Contas Bancárias",
    route: TabsMenuOptionsRoutes.ContaBancarias,
    permissions: [],
  },
  {
    label: "Centros de Custo",
    route: TabsMenuOptionsRoutes.CentrosDeCusto,
    permissions: [],
  },
  {
    label: "Métodos de Cobrança",
    route: TabsMenuOptionsRoutes.MetodosCobranca,
    permissions: [],
  },
  {
    label: "Parametrizações de Cobrança",
    route: TabsMenuOptionsRoutes.Parametrizacoes,
    permissions: [],
  },
  {
    label: "Plano de Contas",
    route: TabsMenuOptionsRoutes.PlanoDeContas,
    permissions: [],
  },
  {
    label: "Grupos de Desconto",
    route: TabsMenuOptionsRoutes.GruposDeDesconto,
    permissions: [],
  },
  {
    label: "Instruções adicionais para boletos",
    route: TabsMenuOptionsRoutes.InstrucaoBoleto,
    permissions: [],
  },
  {
    label: "Feriados",
    route: TabsMenuOptionsRoutes.Feriados,
    permissions: [],
  },
  {
    label: "White Label",
    route: TabsMenuOptionsRoutes.WhiteLabel,
    permissions: [PermissaoEnum.Backoffice.WhiteLabel.Gerenciar],
  },
];
